import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useReactiveVar } from "@apollo/client";
import ProjectsList from "./projectsList";
import PageHeader from "../../components/heading";
import { usePageNotificationsForUserQuery } from "../../graphql/notification.hooks";
import { PublishToast } from "../../components/toast/publish-toast/PublishToast";
import { PaymentFailedBanner } from "../../components/inputs/toast/paymentFailedBanner/PaymentFailedBanner";
import {
  isPaymentFailedShow,
  isPremiumOnlyRestricted,
  isTrialEndedShow,
} from "../../graphql/state";
import useGetUrlLocale from "../../hooks/useGetUrlLocale";

export default function Projects() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const lng = useGetUrlLocale();
  const isPaymentFailed = useReactiveVar(isPaymentFailedShow);
  const isReadonly = useReactiveVar(isPremiumOnlyRestricted);
  const { data: notificationsData } = usePageNotificationsForUserQuery();

  useEffect(() => {
    document.title = "Projects";
  }, []);

  return (
    <div className="position-relative">
      {isReadonly && (
        <div
          className="position-absolute top-0 start-0 w-100 h-100"
          role="button"
          tabIndex={0}
          aria-label={t("payment.Premium")}
          onClick={() => isTrialEndedShow(true)}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              isTrialEndedShow(true);
            }
          }}
          style={{ zIndex: 10, cursor: "not-allowed" }}
        />
      )}
      <PageHeader
        title={t("projects.main")}
        paths={[
          { label: t("folder.projects"), path: "/projects" },
          { label: "", path: "" },
        ]}
        isProjects={true}
      />
      <div className="d-grid gap-2 gap-md-3 mb-3">
        {notificationsData?.pageNotificationsForUser.map(
          ({ publicUrl, id }) => (
            <PublishToast key={id} link={publicUrl} id={id} />
          )
        )}
      </div>
      {/* Stays above the read-only overlay so the payment CTA is clickable */}
      <div className="position-relative" style={{ zIndex: 11 }}>
        <PaymentFailedBanner
          show={isPaymentFailed}
          onAction={() => navigate(`${lng}/payment`)}
        />
      </div>
      <ProjectsList isReadonly={isReadonly} />
    </div>
  );
}
